import URL from '@/tools/url';
import jquery from 'jquery';
import { setupCsrfToken } from '@/ajax/shop/helpers/setupCsrfToken';
import { CAPTCHA_TYPE_GOOGLE, CAPTCHA_TYPE_YANDEX } from '@/constants';

/**
 * @memberof module:ajaxAPI/shop
 * @alias message
 *
 * @description
 * Отпаравка сообщений
 *
 * @param {Object} message - объект с полями
 * @param {string} message.content - тело сообщения. Обязательно
 * @param {string} message.from - e-mail, с которого "отправлено" сообщение. Обязательно
 * @param {string} message.phone - телефон, указывается в теле письма. По-умолчанию - пустое
 * @param {string} message.name - имя, указывается в теле письма. По-умолчанию - пустое.
 * @param {string} options.subject - тема письма.
 *
 * @return {$.ajax} - поток задачи
 *
 * @example
 * ajaxAPI.shop.message({
 *   'from': 'json@test.ru',
 *   'name': 'test is my name',
 *   'subject': 'test is my subject',
 *   'content': 'YAAAAR!!!!',
 *   'phone': '+00000000000000'
 * })
 *  .done(function (onDone) { console.log('onDone: ', onDone) })
 *  .fail(function (onFail) { console.log('onFail: ', onFail) });
 */
export default function(message) {
  setupCsrfToken();

  const captchaType = window.Shop.config.config.captcha_type;

  const result = jquery.Deferred();
  const _lang = URL.getKeyValue('lang') || '';
  const _message = {
    lang: _lang,
    feedback: message
  };

  if (captchaType === CAPTCHA_TYPE_YANDEX) {
    _message['yandex-smart-token'] = message['yandex-smart-token'] || null;
  } else if (captchaType === CAPTCHA_TYPE_GOOGLE) {
    _message.recaptcha_type = message.recaptcha_type || null;
    _message['g-recaptcha-response'] = message['g-recaptcha-response'] || null;
  }

  jquery.post('/client_account/feedback.json', _message)
    .done(function(response) {
      if (_message && response.status == 'ok') {
        result.resolve(response);
      } else {
        response.message = _message;
        result.reject(response);
      }
    })
    .fail(function(response) {
      response.message = _message;
      result.reject(response);
    });

  return result.promise();
}
